import React from 'react';
import { Link } from 'react-router-dom';

function PreviewPage() {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f5f5f5',
      zIndex: 1000
    }}>
      {/* Header with navigation - stays on top */}
      <div style={{
        backgroundColor: '#fff',
        borderBottom: '2px solid #2196F3',
        padding: '12px 20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
        height: '60px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <h2 style={{ margin: '0', fontSize: '18px', fontWeight: 'bold', color: '#1976D2' }}>
            📺 Site Preview (Full Screen)
          </h2>
          <span style={{ fontSize: '12px', color: '#999' }}>
            Viewing: localhost:8000
          </span>
        </div>
        
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <a 
            href="http://localhost:8000" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              padding: '8px 16px',
              backgroundColor: '#4CAF50',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer',
              fontWeight: '500',
              border: 'none',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#388E3C'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4CAF50'}
          >
            Open in New Tab ↗
          </a>
          
          <Link 
            to="/" 
            style={{
              padding: '8px 16px',
              backgroundColor: '#2196F3',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer',
              fontWeight: '500',
              display: 'inline-block',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1976D2'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2196F3'}
          >
            ← Back to Editor
          </Link>
        </div>
      </div>

      {/* Full-screen iframe - takes up remaining space */}
      <iframe
        src="http://localhost:8000"
        style={{
          flex: 1,
          border: 'none',
          width: '100%',
          height: '100%'
        }}
        title="Public Site Preview"
        allow="all"
      />
    </div>
  );
}

export default PreviewPage;
